<template>
  <div>
    <p class="see_detail" @click="visible = true;getDetail()">查看详情</p>

    <el-dialog
      title="个人记工-包工"
      :visible.sync="visible"
      width="800px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="title"><span>当前项目：</span>{{ detail.projectName }}</div>
      <div class="content">
        <el-row class="card_item">
          <el-col class="card_item" :span="12"><span class="color666">日期：</span>{{ workTime }}</el-col>
          <el-col class="card_item" v-if="$route.query.type==='2'" :span="12"><span class="color666">工人：</span>{{ detail.workerName }}</el-col>
          <el-col class="card_item" :span="12" v-if="detail.quantities"><span class="color666">工程量：</span>{{ detail.quantities }}{{ list[Number(detail.quantitiesUnit)-1] }}</el-col>

          <el-col class="card_item" :span="12" v-if="detail.unitPrice"><span class="color666">单价：</span>{{ detail.unitPrice }}元</el-col>
          <el-col class="card_item" :span="12"><span class="color666">工钱：</span>{{ detail.salary }}元</el-col>
        </el-row>
        <div style="display: flex" class="card_item" v-if="detail.remark">
          <div style="width:3em"><span class="color666">备注：</span></div>
          <div style="flex:1">{{ detail.remark }}</div>
        </div>
        <div style="display: flex" v-if="detail.picture">
          <div style="width:3em"></div>
          <div style="flex:1">
            <el-image v-for="(item,index) in detail.picture.split(',')" :key="index" :src="item"
                      :preview-src-list="[item]"
                      class="pics"></el-image>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {api} from "@/api/apiRecord"

export default {
  name: "workBaoDetail",
  props: {
    project: {
      type: [Object, undefined],
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false,
      detail: {},
      list: ["平方米", "立方米", "吨", "米", "寸", "个", "次", "天", "块", "组", "台", "捆", "宗", "项", "株"], // 工程量单位列表
    }
  },
  methods: {
    async getDetail() {
      const params = {
        no:this.project.workRecordNo,
        type:this.$route.query.type
      }
      const res = await api.workWrapDetail(params)
      if (res.data.code === 200) {
        this.detail = res.data.data
      }
    }
  },
  computed: {
    workTime() {
      const time = new Date(this.detail.workTime)
      return `${time.getFullYear()}年${time.getMonth() + 1}月${time.getDate()}日`
    }
  }
}
</script>

<style lang="scss" scoped>
.see_detail {
  color: #0286DF;
  cursor: pointer;
}

/deep/ .el-dialog__body {
  padding: 0;
}

.title {
  padding: 0 20px;
  background: #F5F7FA;
  line-height: 40px;
  font-size: 16px;

  span {
    color: #666;
    font-weight: normal;
  }
}

.content {
  padding: 20px;
}

.color666 {
  color: #666666;
}

.salary {
  color: #FF6600;
  margin-right: 20px;
}

.pics {
  width: 100px;
  height: 100px;
  margin-right: 20px;
}

.card_item {
  margin-bottom: 15px;
  color: #333333
}
.card_item:last-of-type{
  margin-bottom: 0
}

/deep/ .el-dialog__footer {
  padding: 0;
}
</style>
